import { takeEvery, select, put } from 'redux-saga/effects'
import { FEATURE_SAVED } from 'actions/feature/features'
import { getSelectedId } from 'selectors/navigator'

export function* watchFeatureSavedToFixTempId() {
  yield takeEvery(FEATURE_SAVED, fixTempId)
}

function* fixTempId({ data }) {
  const { feature } = data
  const selectedId = yield select(getSelectedId)

  if (selectedId) {
    const entities = [
      ...Object.values(feature.conditions || {}),
      ...Object.values(feature.queries || {}),
      ...Object.values(feature.functions || {}),
      ...Object.values(feature.outputs || {}),
    ]

    // search for selectedId that matches tempId or ends with tempId
    const [{ id, uri } = {}] =
      entities.filter(
        ({ tempId }) =>
          tempId === selectedId || `${selectedId}`.endsWith(tempId)
      ) || []

    // some entities are registered via uri instead of id
    if (uri) {
      yield put({ type: 'SET_SELECTED_ID', id: uri })
    } else if (id) {
      yield put({ type: 'SET_SELECTED_ID', id })
    }
  }
}
